import loginLeftBgImage from "./assets/images/app/digiPub/auth/login-left-bg.png";
import loginRightLogo from "./assets/images/app/digiPub/auth/auth-right-sub-logo.svg";
import sidebarSMLogo from "./assets/images/app/digiPub/sidebar/sidebar-sm-logo.svg";
import modalLogoutIcon from "./assets/images/app/digiPub/modal-logout-icon.svg";

import showEyeIcon from "./assets/images/app/digiPub/auth/show-eye-icon.svg";
import hideEyeIcon from "./assets/images/app/digiPub/auth/hide-eye-icon.svg";

import sideBarLogoImg from "./assets/images/app/common/pured-logo-white.svg";
import logo from "./assets/images/logo/our-village-logo.svg";

import avatarPlaceholder from "./assets/images/app/common/avatar-paceholder.png";
const APP_CONFIG = {
    APP_NAME: "Plate-talk",
    AUTH_LEFT_TEXT: "",
    LOGIN_LEFT_MAIN_TEXT: "",
    LOGIN_LEFT_SUB_TEXT: "",
    OPEN_SIDEBAR_APP_LOGO_SIZE: { width: "70", height: "70" },
    COLLAPSED_SIDEBAR_APP_LOGO: { width: "45", height: "40" },

    IMAGES: {
        APP_LOGO: logo,
        OPEN_SIDEBAR_APP_LOGO: sideBarLogoImg,
        COLLAPSED_SIDEBAR_APP_LOGO: sideBarLogoImg,
        LOGIN_LEFT_BG_IMAGE: loginLeftBgImage,
        // AVATAR_PLACEHOLDER: logo,
        AVATAR_PLACEHOLDER: avatarPlaceholder,
        SHOW_EYE_ICON: showEyeIcon,
        SHOW_HIDE_ICON: hideEyeIcon,
        SIDEBAR_SM_LOGO: sidebarSMLogo,
        AUTH_LEFT_OVERLAY_IMAGE: "",
        LOGIN_RIGHT_IMAGE: loginRightLogo,
        LOGIN_LEFT_MAIN_IMAGE: null,
        MODAL_LOGOUT_ICON: modalLogoutIcon,
        ICON_PLACEHOLDER: "https://icons8.com/icon/OZzk5umGngVd/icon"
        // ICON_PLACEHOLDER: logo
    },

    IS_FOOTER: false,
    FOOTER_CONTENT: "",
    IS_VERTICAL_LAYOUT_NOTIFIACTION: false,
    IS_HORIZONTAL_LAYOUT_NOTIFIACTION: false
};

export default APP_CONFIG;
